import { render, staticRenderFns } from "./CutoffResultsItem.vue?vue&type=template&id=ae9bb3c2&scoped=true"
import script from "./CutoffResultsItem.vue?vue&type=script&lang=ts"
export * from "./CutoffResultsItem.vue?vue&type=script&lang=ts"
import style0 from "./CutoffResultsItem.vue?vue&type=style&index=0&id=ae9bb3c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9bb3c2",
  null
  
)

export default component.exports